import React from 'react';
import { MuiThemeProvider, CssBaseline } from '@material-ui/core';
import { BrowserRouter } from 'react-router-dom';
import Routes from './Components/Routes';
import PageView from './Layouts/PageLayout';

import { MessagesProvider } from './contexts';
import Themes from './theme';
import './index.css';

const App = () => {
  return (
    <MuiThemeProvider theme={Themes}>
      <MessagesProvider>
        <BrowserRouter>
          <PageView>
            <CssBaseline />
            <Routes />
          </PageView>
        </BrowserRouter>
      </MessagesProvider>
    </MuiThemeProvider>
  );
};

export default App;
